import { Navigate, Route, Routes } from 'react-router-dom';

import { DefaultLayout2, GuardScope, useAccessGuard } from '@web/app/shared';

import { PromptsPage } from '../pages';

export const PROMPTS_ROUTE_PATHS = {
    ROOT: '/',
    DETAIL: '/:id',
} as const;

export const PromptsRoutes = () => {
    // TODO: 추후 GuardScope.Project로 변경 예정
    useAccessGuard(GuardScope.Workspace);
    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path={PROMPTS_ROUTE_PATHS.ROOT} element={<PromptsPage />} />
                <Route path={PROMPTS_ROUTE_PATHS.DETAIL} element={<PromptsPage />} />
                <Route path="*" element={<Navigate to="/prompts" replace />} />
            </Route>
        </Routes>
    );
};
